<template>
  <div class="chat-footer" ref="footerRef">
    <div class="product-box" v-if="productInfo">
      <div class="info">
        <div class="left">
          <img :src="productInfo.pic_url" alt="">
        </div>
        <div class="right">
          <div class="top">{{ productInfo.name }}</div>
          <div class="bottom">
            <div class="price">{{ productInfo.market_price }}</div>
          </div>
        </div>
        <div class="close" @click="closeProduct">
          <img src="../image/close.png" alt="close">
        </div>
        <div class="btn" @click="sendProduct">发送商品</div>
      </div>
    </div>
    <div style="background: #f6f6f6;">
      <!-- <div class="quick-box">
        <div class="title">快速了解</div>
        <div class="tag">都有什么套餐？</div>
        <div class="tag">都有什么套餐？</div>
        <div class="tag">都有什么套餐？</div>
        <div class="tag">都有什么套餐？</div>
        <div class="tag">都有什么套餐？</div>
        <div class="tag">都有什么套餐？</div>
        <div class="tag">都有什么套餐？</div>
      </div> -->
      <div class="inp-box">
        <textarea
          ref="text-input"
          rows="4"
          resize="false"
          v-model="messageContent"
          class="text-input"
          placeholder="请输入您要咨询的问题"
          @focus="openMenuBottom('')"
        ></textarea>
        <!-- @focus="focus = true"
          @blur="focus = false"
          @input="inputChange"
          @keydown.enter.exact.prevent="handleEnter"
          @keyup.ctrl.enter.prevent.exact="handleLine"
          @keydown.up.stop="handleUp"
          @keydown.down.stop="handleDown" -->
        <!-- <input class="inp" v-model="messageContent" placeholder="请输入您要咨询的问题" @focus="openMenuBottom('')"> -->
        <div class="right">
          <img :src="require('../image/emoji.png')" alt="emoji" v-show="['', 'other'].includes(menuType)" style="margin-right: .3rem;" @click="openMenuBottom('emoji')">
          <img :src="require('../image/keyboard.png')" alt="emoji" v-show="menuType === 'emoji'" style="margin-right: .3rem;" @click="openMenuBottom('')">
          <img :src="require('../image/other.png')" alt="other" v-show="messageContent === ''" @click="openMenuBottom('other')">
          <button class="send-btn" v-show="messageContent !== ''" @click="sendTextMessage">发送</button>
        </div>
      </div>
    </div>
    <div class="menu-box emoji-box" v-show="menuType === 'emoji'">
      <div v-for="item in emojiName" class="emoji" :key="item" @click="chooseEmoji(item)">
        <img :src="emojiUrl + emojiMap[item]" style="width: .6rem;height: .6rem;" />
      </div>
    </div>
    <div class="menu-box other-box" v-show="menuType === 'other'">
      <div v-for="item in otherName" class="menu" :key="item.key"  @click="handleSendClick(item.key)">
        <img :src="item.img" style="width: .6rem;height: .6rem" />
      </div>
    </div>
    <input
      type="file"
      id="imagePicker"
      ref="imagePicker"
      accept="image/*;video/mp4;"
      @change="handleSelectFile"
      style="display:none"
    />
    <input
      type="file"
      id="videoPicker"
      ref="videoPicker"
      capture="camera"
      @change="handleSelectFile"
      style="display:none"
    />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { emojiMap, emojiName, emojiUrl } from '../utils/emojiMap'
import { otherName } from '../utils/otherMap'

export default {
  name: 'ChatFooter',
  data () {
    return {
      emojiMap: emojiMap,
      emojiName: emojiName,
      emojiUrl: emojiUrl,
      otherName: otherName,
      messageContent: '',
      // emoji 表情 other 图片 视频
      menuType: ''
    }
  },
  computed: {
    ...mapGetters('chat', ['toAccount', 'currentConversationType']),
    ...mapState('chat', ['productInfo'])
  },
  mounted () {},
  methods: {
    openMenuBottom (type) {
      if (this.menuType === type) {
        this.menuType = ''
      } else {
        this.menuType = type
      }
      this.$emit('openMenu')
    },
    chooseEmoji (item) {
      this.messageContent += item
    },
    handleSendClick (type) {
      this.$refs[`${type}Picker`].click()
    },
    sendTextMessage () {
      if (
        this.messageContent === '' ||
        this.messageContent.trim().length === 0
      ) {
        this.messageContent = ''
        this.$toast('不能发送空消息哦！')
        return
      }
      if (this.currentConversationType === this.TIM.TYPES.CONV_GROUP && this.groupAt) {
        let message = this.tim.createTextAtMessage({
          to: this.toAccount,
          conversationType: this.TIM.TYPES.CONV_GROUP,
          payload: {
            text: this.messageContent,
            atUserList: this.callingList // 'denny' 'lucy' 都是 userID，而非昵称
          }
        })
        const msgData = JSON.parse(JSON.stringify(message))
        this.$store.commit('chat/pushCurrentMessageList', msgData)
        this.$bus.$emit('scroll-bottom')
        this.tim.sendMessage(message).catch(error => {
          this.$toast(error.message)
          // this.$store.commit('showMessage', {
          //   type: 'error',
          //   message: error.message
          // })
        })
        this.messageContent = ''
        this.groupAt = false
        return
      }
      const message = this.tim.createTextMessage({
        to: this.toAccount,
        conversationType: this.currentConversationType,
        payload: { text: this.messageContent }
      })
      const msgData = JSON.parse(JSON.stringify(message))
      this.$store.commit('chat/pushCurrentMessageList', msgData)
      this.$bus.$emit('scroll-bottom')
      this.tim.sendMessage(message).catch(error => {
        this.$toast(error.message)
        // this.$store.commit('showMessage', {
        //   type: 'error',
        //   message: error.message
        // })
      })
      this.messageContent = ''
    },
    handleSelectFile (e) {
      const file = e.target.files
      console.log(file)
      if (file) {
        if (file[0].type.includes('image')) {
          this.sendImage(file[0])
        } else if (file[0].type.includes('video')) {
          this.sendVideo(file[0])
        } else {
          this.$toast('请选择图片或视频')
        }
      } else {
        this.$toast('文件有问题')
      }
    },
    sendImage (file) {
      const message = this.tim.createImageMessage({
        to: this.toAccount,
        conversationType: this.currentConversationType,
        payload: { file },
        // payload: {
        //   file: document.getElementById('imagePicker') // 或者用event.target
        // },
        onProgress: percent => {
          this.$set(message, 'progress', percent) // 手动给message 实例加个响应式属性: progress
        }
      })
      this.tim
        .sendMessage(message)
        .then(() => {
          this.$store.commit('chat/pushCurrentMessageList', message)
          this.$refs.imagePicker.value = null
        })
        .catch(imError => {
          this.$toast(imError.message)
          // this.$store.commit('showMessage', {
          //   message: imError.message,
          //   type: 'error'
          // })
        })
    },
    sendVideo (file) {
      const message = this.tim.createVideoMessage({
        to: this.toAccount,
        conversationType: this.currentConversationType,
        payload: { file },
        // payload: {
        //   file: document.getElementById('videoPicker') // 或者用event.target
        // },
        onProgress: percent => {
          this.$set(message, 'progress', percent) // 手动给message 实例加个响应式属性: progress
        }
      })
      this.tim
        .sendMessage(message)
        .then(() => {
          this.$store.commit('chat/pushCurrentMessageList', message)
          this.$refs.videoPicker.value = null
        })
        .catch(imError => {
          this.$toast(imError.message)
          // this.$store.commit('showMessage', {
          //   message: imError.message,
          //   type: 'error'
          // })
        })
    },
    closeProduct () {
      this.$store.commit('chat/updateProductInfo', false)
      this.$emit('openMenu') // 重新计算页面高度
    },
    sendProduct () {
      this.messageContent = this.productInfo.productUrl
      this.sendTextMessage()
      this.messageContent = ''
    }
  }
}
</script>

<style lang="less" scoped>
.chat-footer {
  width: 100%;

  .product-box {
    padding: .2rem .3rem;

    .info {
      height: 2rem;
      background: #ffffff;
      border-radius: .1rem;
      padding: .2rem .24rem;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;

      .left {
        width: 1.6rem;
        height: 1.6rem;
        margin-right: .15rem;
        flex-shrink: 0;
      }
      .right {
        height: 1.6rem;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        font-size: .26rem;
        color: #121212;

        .top {
          width: 90%;
          margin-top: .1rem;
          .ellipsis2;
        }
        .bottom {
          .price {
            &::before {
              content: '¥';
            }
          }
        }
      }

      .close {
        width: .16rem;
        height: .16rem;
        position: absolute;
        right: .2rem;
        top: .2rem;
      }
      .btn {
        position: absolute;
        right: .2rem;
        bottom: .2rem;
        width: 1.45rem;
        height: .6rem;
        background: #ff5d5d;
        border-radius: .3rem;
        font-size: .24rem;
        color: #ffffff;
        line-height: .6rem;
        text-align: center;
      }
    }
  }

  .quick-box {
    padding: .06rem .2rem 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    .title {
      font-size: .22rem;
      color: #7F7F7F;
      flex-shrink: 0;
      margin-top: .12rem;
      margin-right: .15rem;
    }

    .tag {
      background: #edf4fb;
      border: 0.02rem solid #c9e0ff;
      border-radius: 0.8rem;
      padding: .12rem .1rem;
      font-size: .22rem;
      color: #3B8DFF;
      margin-top: .12rem;
      margin-right: .15rem;
    }
  }

  .inp-box {
    padding: .2rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0;

    .text-input {
      height: .78rem;
      background: #fdfdfd;
      border: .01rem solid #d1d1d1;
      border-radius: .08rem;
      font-size: .26rem;
      color: #333;
      padding: .2rem;
      flex: 1;
      box-sizing: border-box;

      &::-webkit-input-placeholder { /* WebKit, Blink, Edge */
        color: #B9B9B9;
      }
      &::-moz-placeholder { /* Mozilla Firefox 4 to 18 */
        color: #B9B9B9;
      }
      &::-moz-placeholder { /* Mozilla Firefox 19+ */
        color: #B9B9B9;
      }
      &::-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: #B9B9B9;
      }
    }

    .right {
      margin-left: .25rem;
      flex-shrink: 0;
      display: flex;
      align-items: center;

      img {
        width: .54rem;
      }

      .send-btn {
        width: 1.12rem;
        height: .6rem;
        background: #06cd61;
        border-radius: .06rem;
        text-align: center;
        line-height: .6rem;
        font-size: .28rem;
        color: #fff;
      }
    }
  }

  .menu-box {
    max-height: 5rem;
    overflow-y: scroll;
    box-sizing: border-box;
    padding: .24rem;
    background: #d8dade;

    &.emoji-box {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-around;

      .emoji {
        height: .64rem;
        width: .64rem;
        padding: .2rem;
      }
    }

    &.menu-box {
      display: flex;
      flex-wrap: wrap;

      .menu {
        width: 1.32rem;
        height: 1.32rem;
        background: #b9b9b9;
        border-radius: .1rem;
        display: flex;
        justify-content: center;
        align-items: center;

        & + .menu {
          margin-left: .6rem;
        }
      }
    }
  }
}
</style>
